module.exports = __webpack_public_path__ + "static/img/home_lun1.17b7b29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_lun1.jpg
// module id = ob5S
// module chunks = 1